const translation = {
  title: 'Explorar',
  sidebar: {
    discovery: 'Descubrimiento',
    chat: 'Chat',
    workspace: 'Espacio de trabajo',
    action: {
      pin: 'Anclar',
      unpin: 'Desanclar',
      rename: 'Renombrar',
      delete: 'Eliminar',
    },
    delete: {
      title: 'Eliminar aplicación',
      content: '¿Estás seguro de que quieres eliminar esta aplicación?',
    },
  },
  apps: {
    title: 'Explorar aplicaciones de Dify',
    description: 'Utiliza estas aplicaciones de plantilla al instante o personaliza tus propias aplicaciones basadas en las plantillas.',
    allCategories: 'Recomendado',
  },
  appCard: {
    addToWorkspace: 'Agregar al espacio de trabajo',
    customize: 'Personalizar',
  },
  appCustomize: {
    title: 'Crear aplicación a partir de {{name}}',
    subTitle: 'Icono y nombre de la aplicación',
    nameRequired: 'El nombre de la aplicación es obligatorio',
  },
  category: {
    Assistant: 'Asistente',
    Writing: 'Escritura',
    Translate: 'Traducción',
    Programming: 'Programación',
    HR: 'Recursos Humanos',
    Agent: 'Agente',
    Workflow: 'Flujo de trabajo',
    Entertainment: 'Entretenimiento',
  },
}

export default translation
